import { createBrowserHistory } from 'history';

export function getBrowserHistory() {
  if (!window.homeChefBrowserHistory) {
    window.homeChefBrowserHistory = createBrowserHistory();
  }

  return window.homeChefBrowserHistory;
}
